export interface Settings {
    componentId: string;
    instanceId: string;
    editor: DisplaySettings;
    viewer: DisplaySettings;
}

export interface DisplaySettings {
    placeId?: string;
    placeUrl?: string;
    placeName?: string;
    minStarCount?: number;
    dateFormat?: DateFormat;
    manual?: boolean;
    speed?: number;
    usePinned?: boolean;
    size?: number;
    minTime?: number;
    nameFormat?: NameFormat;
    nameFont?: string;
    nameSize?: string;
    textFont?: string;
    textSize?: number;
    className?: string;
    textReviewsOnly?: boolean;
    randomOrder?: boolean;
    noLinks?: boolean;
    forcePostFilter?: boolean;

    backgroundColor?: string;
    textColor?: string;
    hiddenReviews?: string[];
}

export type DateFormat = 'DD/MM/YYYY' | 'MM/DD/YYYY' | 'Hide';

export type NameFormat = 'full' | 'first-name-only' | 'first-name-without-initials' | 'initials';
export const NAME_FORMATS_ORDER: NameFormat[] = ['full', 'first-name-only', 'first-name-without-initials', 'initials'];
export const NAME_FORMAT_LABELS: Record<NameFormat, string> = {
    'full': 'Full name',
    'first-name-only': 'First name + initials',
    'first-name-without-initials': 'First name',
    'initials': 'Initials',
}
